import { Navigate, useParams } from "react-router";

import type { TourTaskType } from "@/libs/api/types";

import { routePaths } from "@/App";
import { lazy, Suspense } from "react";
import { GatherTaskPickUpSkeleton } from "./GatherPickupPage";
import { OrderPickUpSkeleton } from "./OrderPickupPage";

type PickUpSearchParams = {
  id: string;
  stopId: string;
  taskType: TourTaskType;
};

const GatherTaskPickUp = lazy(() => import("./GatherPickupPage"));
const OrderPickup = lazy(() => import("./OrderPickupPage"));

export function PickUpPage() {
  const { id, stopId, taskType } = useParams<PickUpSearchParams>();

  if (typeof id !== "string" || typeof stopId !== "string") {
    return <Navigate to={routePaths.home} />;
  }

  if (taskType === "order-pickup") {
    return (
      <Suspense fallback={<OrderPickUpSkeleton />}>
        <OrderPickup stopId={stopId} tourId={id} />
      </Suspense>
    );
  }

  if (taskType === "gatherTask-pickup") {
    return (
      <Suspense fallback={<GatherTaskPickUpSkeleton />}>
        <GatherTaskPickUp stopId={stopId} tourId={id} />
      </Suspense>
    );
  }
}
